<template>
  <hm-content title="活动列表">
    <div class="table-panel flex flex-between">
      <div>
        <el-button
          class="mr10"
          type="primary"
          plain
          size="small"
          @click="addActivity"
          >创建活动</el-button
        >
        <input
          type="text"
          class="url"
          :value="activityListUrl"
          ref="activityListUrl"
        />
        <el-button type="primary" plain size="small" @click="copyUrl"
          >复制活动列表地址</el-button
        >
      </div>
      <div>
        <el-date-picker
          v-model="applyDate"
          type="daterange"
          align="right"
          start-placeholder="报名开始时间"
          end-placeholder="报名结束时间"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-select
          clearable
          v-model="actStatus"
          placeholder="活动状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="开启" value="1"></el-option>
          <el-option label="关闭" value="0"></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="actName"
          placeholder="输入活动名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <div class="hm-radio-group">
        <el-radio-group v-model="timeStatus" size="small" @change="switchTab">
          <el-radio-button label="all"
            >全部({{ subscribeActiveListCount.all }})</el-radio-button
          >
          <el-radio-button label="running"
            >进行中({{ subscribeActiveListCount.running }})</el-radio-button
          >
          <el-radio-button label="notStart"
            >未开始({{ subscribeActiveListCount.notStart }})</el-radio-button
          >
          <el-radio-button label="end"
            >已结束({{ subscribeActiveListCount.end }})</el-radio-button
          >
        </el-radio-group>
      </div>
      <el-table
        stripe
        :data="subscribeActivityList.records"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="活动名称">
          <template slot-scope="scope">
            <div class="table-status flex item-center">
              <span
                class="status success-bg"
                v-show="scope.row.timeStatus === 'running'"
              ></span>
              <span
                class="status gray-bg"
                v-show="scope.row.timeStatus === 'notStart'"
              ></span>
              <span
                class="status danger-bg"
                v-show="scope.row.timeStatus === 'end'"
              ></span>
              <span class="flex flex-1 flex-start">{{
                scope.row.actName
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="240px"
          prop="startDateFormat"
          label="活动日期"
        >
          <template slot-scope="scope">
            <span class="time">
              {{ scope.row.actStartTime.split(" ")[0] }}至{{
                scope.row.actEndTime.split(" ")[0]
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          width="300px"
          prop="serverGuider"
          label="报名时间"
        >
          <template slot-scope="scope">
            <span class="time">
              {{ scope.row.applyStartTime }}至{{ scope.row.applyEndTime }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actSite"
          label="地点"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="suitPerson"
          label="适合人群"
        >
        </el-table-column>
        <el-table-column header-align="center" align="center" label="活动主图">
          <template slot-scope="scope">
            <img
              style="width:100%;"
              :src="scope.row.mainImgUrl"
              alt="活动主图"
            />
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="报名人数"
          prop="realApplyNum"
        >
          <template slot-scope="scope">
            {{ scope.row.realApplyNum }}/{{ scope.row.actMemberUpperLimit }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="状态"
          prop="actStatus"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.actStatus == 1" class="success">开启</span>
            <span v-if="scope.row.actStatus == 0" class="danger">关闭</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="查看" placement="top">
                <div class="pointer mr10" @click="toDetails(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="报名详情" placement="top">
                <div class="pointer mr10" @click="toReservitionList(scope.row)">
                  <span class="hmicon icon-chazhaobiaodanliebiao blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="编辑" placement="top">
                <div
                  class="pointer mr10"
                  @click="edit(scope.row)"
                  v-show="scope.row.auditState !== 'audit_pass'"
                >
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <div
                  class="pointer mr10"
                  @click="remove(scope.row)"
                  v-show="
                    scope.row.auditState !== 'audit_pass' ||
                      (scope.row.auditState === 'audit_pass' &&
                        scope.row.enabledState === 'disabled')
                  "
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <hm-status />
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="subscribeActivityList.total"
        @current-change="paging"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import HmStatus from "@/components/HmStatus";
import moment from "moment";
import { getLoginUser } from "@/utils/auth";
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: { HmStatus },
  data() {
    return {
      currentPage: 1,
      timeStatus: "all",
      pageSize: 10,
      isOutputing: false,
      applyDate: [],
      actStatus: "",
      actName: "",
      activityListUrl: "",
      singleUrl: ""
    };
  },
  created() {
    const echoParams = getCookie({ key: "EVENTLIST", type: "session" });
    if (echoParams) {
      for (let key in echoParams) {
        if (this.hasOwnProperty(key)) {
          this[key] = echoParams[key];
        }
      }
      if (echoParams.startDate && echoParams.endDate) {
        this.date = [
          new Date(echoParams.startDate),
          new Date(echoParams.endDate)
        ];
      }
      this.currentPage = echoParams.pageNo;
    }
  },
  mounted() {
    this.queryList().then(res => {
      this.activityListUrl = res.result.shareUrl;
    });
  },
  computed: mapGetters([
    "subscribeActivityList",
    "subscribeActiveListCount",
    "allSubscribeActivityList"
  ]),
  watch: {
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  },
  methods: {
    copyUrl() {
      const input = this.$refs.activityListUrl;
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
    },
    toReservitionList(row) {
      this.$router.push({
        name: "ViewReservitionList",
        query: {
          id: row.id,
          actName: row.actName
        }
      });
    },
    toDetails(row) {
      this.$router.push({
        name: "EventDetails",
        query: {
          id: row.id
        }
      });
    },
    edit(row) {
      this.$router.push({
        name: "EditEvent",
        query: {
          id: row.id
        }
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(() => {
            const list = this.allSubscribeActivityList.records;
            list.forEach(v => {
              v.actDate = `${v.actStartTime}至${v.actEndTime}`;
              v.applyDate = `${v.applyStartTime}至${v.applyEndTime}`;
              v.realApplyNums = `${v.realApplyNum}/${v.actMemberUpperLimit}`;
              if (v.actCostMoney && !v.actCostIntegral) {
                v.cost = `${v.actCostMoney}元`;
              } else if (v.actCostMoney && v.actCostIntegral) {
                v.cost = `${v.actCostMoney}元/${v.actCostIntegral}积分`;
              } else if (v.actCostIntegral && !v.actCostMoney) {
                v.cost = `${v.actCostIntegral}积分`;
              } else {
                v.cost = "免费";
              }
            });

            //  {{ scope.row.realApplyNum }}/{{ scope.row.actMemberUpperLimit }}
            const tHeader = [
              "活动名称",
              "活动日期",
              "报名时间",
              "地点",
              "报名人数",
              "适合人群",
              "主图",
              "状态"
            ];
            const filterVal = [
              "actName",
              "actDate",
              "applyDate",
              "actSite",
              "realApplyNums",
              "suitPerson",
              "mainImgUrl",
              "timeStatusFormat"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(tHeader, data, "活动列表");
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
          this.queryList();
        });
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("delCurrentRowActivity", {
            id: row.id,
            userId: getLoginUser().userId
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    },
    addActivity() {
      this.$router.push({
        name: "AddEvent"
      });
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        applyDate: this.applyDate,
        actName: this.actName,
        actStatus: this.actStatus,
        timeStatus: this.timeStatus
      };
      setCookie({
        key: "EVENTLIST",
        type: "session",
        data: params
      });
      return this.$store.dispatch("querysubscribeActivityList", params);
    },
    queryAllList() {
      const params = {
        pageSize: 999999,
        pageNo: 1,
        applyDate: this.applyDate,
        actName: this.actName,
        actStatus: this.actStatus,
        timeStatus: this.timeStatus
      };
      return this.$store.dispatch("queryAllSubscribeActivityList", params);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}

.url {
  width: 1px;
  opacity: 0;
  border: none;
}
</style>
